import styled from "styled-components";
import { DefaultTheme as theme } from "../../../../../../../../theme";

export const RulesGroup = styled.div`
  border-radius: 8px;
  border: 1px solid ${theme.colors.silverGrayTwo};
  width: 100%;
  padding: 12px;
  margin-block-end: 5px;
  overflow-wrap: break-word;
  word-wrap: break-word; 
  word-break: break-word;
  white-space: normal;
  font-family: ${(props) => props.theme.fonts.family.inter };
`;

export const LogicalOp = styled.div`
  display: flex;
  width: 55px;
  height: 33px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: bold;
  margin-block: 5px;
  padding: 10px;
  border: 1px solid ${theme.colors.silverGrayTwo};
  justify-content: center;
  align-items: center;
  font-family: ${(props) => props.theme.fonts.family.inter };
`;
